import {Tour} from '@/modules/onboarding/tour/Tour';
import {TourName, TourOptions} from '@/modules/onboarding/tour/models/TourOptions';
import {TourStep} from '@/modules/onboarding/tour/models/TourStep';
import {BikKey} from '@/modules/onboarding/tours/enums/BikKey';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {Routes} from '@/router/Routes';
import {EditUserTab} from '@/modules/user/editUser/EditUserTab';
import Vue from 'vue';

const STEPS: TourStep[] = [
  {
    key: BikKey.BIK_NAVIGATION,
    content: I18NGetter().useBikTour.BIK_NAVIGATION,
    params: {
      enableScrolling: false,
    },
    isPreviousButtonHidden: true,
    isNextButtonHidden: true,
    customButtons: [
      {
        label: I18NGetter().PlatformSection.bik,
        primary: false,
        action: async() => {
          // Lazy import router to avoid circular dependencies
          const AppRouter = (await import('@/router')).default;
          await AppRouter.push({
            name: Routes.USER_EDIT,
            query: { tab: EditUserTab.BIG_BIK_QUERIES.toString() }
          });
          // Complete the tour after navigation
          Vue.prototype.$onboarding.tours.BIK.complete();
        }
      }
    ]
  },
];

export default new Tour(TourName.BIK, STEPS as readonly TourStep[], new TourOptions());

